export default {
  title: '数据看板',
  loadingStatus: '数据加载中',
  syncedStatus: '数据已同步',
  refresh: '刷新',
  notRefreshed: '尚未刷新',
  lastRefreshedAt: '最后刷新 {time}',
  todayScanCount: '今日扫码个数',
  todayNewMembers: '今日新增会员',
  totalScanCount: '扫码总个数',
  totalMembers: '会员总数',
  ratioUp: '环比↑ {value}%',
  quickActions: '快捷操作',
  actionProducts: '产品管理',
  actionCodeDisable: '二维码禁用',
  actionActivity: '活动管理',
  actionMemberList: '会员列表',
  actionPointsMall: '积分商城',
  scanTrend: '扫码趋势',
  thisWeek: '本周',
  thisMonth: '本月',
  realtimeScanRecords: '实时扫码记录',
  scanTime: '扫码时间',
  userName: '用户名称',
  scanRegion: '扫码国家/地区',
  legendScanCount: '扫码个数',
  legendScanUsers: '扫码人数',
  legendWinners: '中奖人数',
  unit: '个',
};
